import React, { useState, useCallback, useEffect, useMemo } from 'react';
import * as Styles from './style';
import { Icon } from 'semantic-ui-react';
import CustomButton from 'components/common/custom-button';
import { getCountryImage } from 'components/manage-vm/utils';
import { useTranslation } from 'react-i18next';
import { checkDeletedItems, menuOptions } from './util';
import SlidingPanels from 'components/common/sliding-panel';
import { WhNetworks } from './WhNetworks';
import SettingPanel from './SettingPanel';
import { Dropdowns } from './Dropdown';
import { ServerImage } from './ServerImage';
import { EditLabel } from './EditLabel';
import { useMediaQuery } from '@mui/material';
import { P } from 'components/reusable-css';

const ManageWhCard = ({ deletedIds, setDeletedIds, data, managerWhRefetch, managerWhIsFetching }) => {
  const { t } = useTranslation();
  const match = useMediaQuery('(max-width:550px)');
  const [openConfigurationPanel, setOpenConfigurationPanel] = useState(false);
  const [initialTab, setInitialTab] = useState();
  const checkDisabledItem = useMemo(() => checkDeletedItems(deletedIds, data?.id), [deletedIds, data?.id]);

  const handleClose = () => {};
  const handleOpen = () => {};
  const toggle = () => setOpenConfigurationPanel((prev) => !prev);

  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      setOpenConfigurationPanel(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  return (
    <Styles.Card style={checkDisabledItem} key={data.id}>
      <Styles.CardContent>
        <Styles.StartContent>
          <Styles.Picture>
            <ServerImage data={data} />
          </Styles.Picture>
          <Styles.Border />
          <Styles.Adding center={data.tags}>
            <EditLabel data={data} handleClose={handleClose} handleOpen={handleOpen} />
          </Styles.Adding>
        </Styles.StartContent>
        <Styles.Country>
          <Styles.CountryFlag>
            <Styles.Circle style={{ border: '0.5px solid #C5C5C5' }}>
              <img src={getCountryImage(data?.region, data?.region)} alt="country" />
            </Styles.Circle>
            <h6 style={{ width: '50px' }}>{data?.region}</h6>
            {data?.status && <Styles.Status>{data?.status}</Styles.Status>}
          </Styles.CountryFlag>
          <WhNetworks data={data} />
        </Styles.Country>
        <Styles.WebsiteCount>
          <P style={{ padding: '10px 7px' }}>
            {t(data?.websites_count > 1 ? 'wh/instance.string11' : 'wh/instance.string10', {
              websites_count: data?.websites_count,
              websites_limit: data?.websites_limit,
            })}
          </P>
        </Styles.WebsiteCount>
        <Styles.Backup>
          <CustomButton title={t('wh/instance.string9')} buttonStyles={{ padding: '10px 7px', fontSize: '12px' }} />
        </Styles.Backup>
        <Styles.SettingIcon>
          <Icon
            size="large"
            name="setting"
            onClick={async () => {
              managerWhRefetch();
              setOpenConfigurationPanel(true);
              setInitialTab('');
            }}
          />
        </Styles.SettingIcon>
        <Styles.More>
          <Dropdowns
            setOpenConfigurationPanel={setOpenConfigurationPanel}
            setId={setDeletedIds}
            deletedIds={deletedIds}
            id={data.id}
            data={data}
          />
        </Styles.More>
      </Styles.CardContent>
      <SlidingPanels size={match ? 93 : 78} isOpen={openConfigurationPanel} isClose={setOpenConfigurationPanel}>
        {openConfigurationPanel && (
          <SettingPanel
            data={data}
            menuOptions={menuOptions}
            openConfigurationPanel={openConfigurationPanel}
            setOpenConfigurationPanel={setOpenConfigurationPanel}
            initialTab={initialTab}
            toggle={toggle}
            setDeletedIds={() => setDeletedIds((prev) => [...prev, data.id])}
            managerWhRefetch={managerWhRefetch}
            managerWhIsFetching={managerWhIsFetching}
          />
        )}
      </SlidingPanels>
    </Styles.Card>
  );
};

export default React.memo(ManageWhCard);
